module.exports = __webpack_public_path__ + "img/icon_team_development_party.77036578.png";